import RelatedResult from '../components/RelatedResult'
import React from 'react'

function ProductSlider() {
    return (
        <div className='result_container'>
            <div className="container">
                <div className="row py-5 px-lg-5">
                    <div className='col-12'>
                        <div className='related-result-container'>
                            <RelatedResult/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ProductSlider